/* eslint-disable no-unused-vars */

import Vue from 'vue'

export const OrganizationTreeModule = {
    strict: true,  // for developement only
    namespaced: true,
    state: {
      treeStore: []
    },
    mutations: {
      updateTreeStore(state, newTree) {
        state.treeStore = newTree
      }
    },
    actions: {
        async load({ commit, rootState}, params = Object()) {
            let res = await Vue.prototype.$http.post(rootState.apiUrl+'/organization/list/', params)

            let treeData = new Promise(resolve => {
                const items = {}


                res.data.forEach(item => {
                  const { name } = item;

                  if (false === (name in items)) {
                    items[name] = []
                  }

                  let treeItem = {
                    text: item.version ? `${item.name} ${item.version}` : item.name,
                    data: item
                  }

                  items[name].push(treeItem)
                })

                let o = Object.keys(items).reduce((a, b) => {
                  let children = items[b]
                  let item

                  if (children.length > 1) {
                    item = {
                      text: children[0].data.name,
                      data: Object.assign({}, children[0].data),
                      children
                    }
                  } else {
                    item = children[0]
                    item.data
                  }

                  if (!item.data) {
                    item.data = {
                      type: children[0].data.type,
                      isRoot: true
                    }
                  } else {
                    item.data.isRoot = true
                  }

                  a.push(item)

                  return a
                }, [])

                resolve(o)
              })


            commit('updateTreeStore', res.data)
        },
      updateTree(context, tree) {
        context.commit('updateTreeStore', tree)
      }
    },
    getters: {
      tree(state) {
        return state.treeStore
      }
    }
}
